import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const names = ['Martina P.', 'Sofía C.', 'Camila R.', 'Valentina M.', 'Lucía G.', 'Florencia D.', 'Agustina V.', 'Julieta L.', 'Rocío B.', 'Belén S.', 'Carolina F.', 'Daniela P.', 'Brenda T.', 'Tomás A.', 'Matías N.', 'Nicolás R.', 'Federico C.', 'Lucas M.'];
const cities = ['Buenos Aires', 'Rosario', 'Córdoba', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Resistencia', 'Santa Fe'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: '',
    time: 1
  });
  const [isDismissed, setIsDismissed] = useState(false);
  const dismissedRef = useRef(false);
  const timeoutsRef = useRef<number[]>([]);
  useEffect(() => {
    dismissedRef.current = isDismissed;
  }, [isDismissed]);
  useEffect(() => {
    const scheduleNext = (delay: number) => {
      const id = window.setTimeout(() => {
        if (dismissedRef.current) return;
        const randomName = names[Math.floor(Math.random() * names.length)];
        const randomCity = cities[Math.floor(Math.random() * cities.length)];
        const randomTime = Math.floor(Math.random() * 15) + 1;
        setCurrentData({
          name: randomName,
          city: randomCity,
          time: randomTime
        });
        setIsVisible(true);
        const hideId = window.setTimeout(() => {
          setIsVisible(false);
          if (!dismissedRef.current) {
            const nextDelay = Math.floor(Math.random() * 6000 + 12000);
            scheduleNext(nextDelay);
          }
        }, 6000);
        timeoutsRef.current.push(hideId);
      }, delay);
      timeoutsRef.current.push(id);
    };
    scheduleNext(5000);
    return () => {
      timeoutsRef.current.forEach(id => window.clearTimeout(id));
      timeoutsRef.current = [];
    };
  }, []);
  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };
  return <AnimatePresence data-id="element-124">
      {isVisible && !isDismissed && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-slate-100 p-4 pr-10 max-w-[320px] flex items-start gap-4" data-id="element-125">
          <button onClick={handleDismiss} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600 transition-colors" aria-label="Cerrar notificación" data-id="element-126">
            <X className="w-4 h-4" data-id="element-127" />
          </button>

          <div className="relative flex-shrink-0" data-id="element-128">
            <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-700 font-bold text-sm" data-id="element-129">
              {currentData.name.charAt(0)}
            </div>
            <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5" data-id="element-130">
              <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-131" />
            </div>
          </div>

          <div data-id="element-132">
            <p className="text-sm text-slate-800 font-medium leading-tight mb-1" data-id="element-133">
              <span className="font-bold" data-id="element-134">{currentData.name}</span> de{' '}
              {currentData.city} acaba de comprar KIT Recruiter PRO
            </p>
            <p className="text-xs text-slate-500" data-id="element-135">
              hace {currentData.time}{' '}
              {currentData.time === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}